import { redirect } from '@tanstack/react-router'
import type { Me } from '@/api/queries'
import { canAccess, type NavId } from './navigation'

/** `beforeLoad`-Wächter: Seite nur mit dem Recht aus der Navigationsdefinition. */
export function requireNav(id: NavId) {
  return ({ context }: { context: { me: Me } }) => {
    if (!canAccess(context.me.permissions, id)) throw redirect({ to: '/forbidden', replace: true })
  }
}
